export default __webpack_public_path__ + "static/media/partnerImage.1f1c2e63.png";